import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const PurchaseContractManagement = () => {
  return <CommingSoon />;
};

export default PurchaseContractManagement;
